import { replaceNBSP, Button } from "@endya-conformite/ui-kit";
import AttachFileIcon from "@endya-conformite/ui-kit/src/assets/icons/attach-file.svg?react";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";

import SubdirectoyArrowRight from "@endya-conformite/ui-kit/src/assets/icons/subdirectory-arrow-right.svg?react";
import { RemediationConversation } from "@gateway/controle-quinquennal/controller/controle-quinquennal.definition";
import { useDownloadFileMutation } from "@src/data/files/hook/useDownloadFileMutation";
import classNames from "classnames";
import { Fragment, useState } from "react";
import style from "./Conversation.module.scss";

type ConversationProps = {
  conversation: RemediationConversation;
  siren: string;
  showBorder?: boolean;
  millesime: number;
};

export function Conversation({
  conversation,
  siren,
  showBorder = false,
  millesime,
}: ConversationProps) {
  const { remediation, notes } = conversation;
  const files = remediation?.files || [];

  const [downloadingFileId, setDownloadingFileId] = useState<string | null>(
    null
  );

  const { mutate: downloadFile } = useDownloadFileMutation();

  const handleDownload = (
    fileId: string,
    pathname: string,
    filename: string,
    fileSiren: string
  ) => {
    setDownloadingFileId(fileId);
    downloadFile(
      { siren: fileSiren, millesime, pathname, filename },
      { onSettled: () => setDownloadingFileId(null) }
    );
  };

  if (!remediation && notes.length === 0) return null;

  return (
    <div className={style.commentList}>
      {remediation && (
        <div
          className={classNames(style.commentItem, {
            [style.bordered]: showBorder,
          })}
        >
          <span
            // eslint-disable-next-line react/no-danger -- We sanitize the HTML
            dangerouslySetInnerHTML={{
              __html: replaceNBSP(remediation.description),
            }}
          />
          {files && files.length > 0 && (
            <div className={style.filesList}>
              {files.map((file) => {
                const isThisFileDownloading = downloadingFileId === file.idFile;
                return (
                  <Button
                    key={file.idFile}
                    variant="text"
                    className={style.fileItem}
                    disabled={downloadingFileId !== null}
                    icon={
                      isThisFileDownloading ? <Loader /> : <AttachFileIcon />
                    }
                    onClick={() =>
                      handleDownload(
                        file.idFile,
                        file.pathname,
                        file.filename,
                        siren
                      )
                    }
                  >
                    {file.filename}
                  </Button>
                );
              })}
            </div>
          )}
        </div>
      )}
      {notes && notes.length > 0 && (
        <div className={style.notesList}>
          {notes.map((note) => {
            const contentMatch = note.content.match(
              /^\[([^\]]+)]\s*⚠️\s*NE PAS MODIFIER - COMMENTAIRE ADHERENT\s*(.*)/s
            );
            const cleanContent = contentMatch?.[2] || note.content;
            const noteAuthor =
              note.auteur ?? conversation.auteur ?? "l'adhérent";

            return (
              <Fragment key={note.id}>
                <div className={style.subtitle}>
                  <SubdirectoyArrowRight />
                  <small>
                    Commentaire de <b>{noteAuthor}</b> du{" "}
                    {new Date(note.createdAt).toLocaleDateString("fr-FR")}
                  </small>
                </div>
                <div className={style.item}>
                  <span
                    // eslint-disable-next-line react/no-danger -- We sanitize the HTML
                    dangerouslySetInnerHTML={{
                      __html: replaceNBSP(cleanContent),
                    }}
                  />
                </div>
              </Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
}
